/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Legacy_Close_Track2_ButtonInputs */



/**
* | output |
* | --- |
* | "x Track 2" |
*
* @param {Timeline_Legacy_Close_Track2_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_legacy_close_track2_button = /** @type {((inputs?: Timeline_Legacy_Close_Track2_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Legacy_Close_Track2_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("x Piste 2")
	if (locale === "de") return /** @type {LocalizedString} */ ("x Spur 2")
	if (locale === "it") return /** @type {LocalizedString} */ ("x Traccia 2")
	if (locale === "ru") return /** @type {LocalizedString} */ ("x Трек 2")
	if (locale === "es") return /** @type {LocalizedString} */ ("x Pista 2")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("x 轨道 2")
	if (locale === "ja") return /** @type {LocalizedString} */ ("x トラック2")
	if (locale === "hi") return /** @type {LocalizedString} */ ("x ट्रैक 2")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("x Faixa 2")
	return /** @type {LocalizedString} */ ("x Track 2")
});